module.exports = __webpack_public_path__ + "static/media/eceb1.1f139b2c.png";